import React, { useState } from 'react';
import api from '../../services/api';
import './StockThesis.css';

export default function StockThesis({ symbol, scoreData }) {
  const [thesis, setThesis] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const generateThesis = async () => {
    setLoading(true);
    setError(null);
    try {
      const { data } = await api.post('/chat/thesis', { symbol, score_data: scoreData });
      setThesis(data);
    } catch (err) {
      // Tier-limit errors are handled globally by LimitReachedModal
      if (!err.tierDetail) {
        setError(err.message);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="stock-thesis">
      {!thesis && !loading && (
        <button className="thesis-generate-btn" onClick={generateThesis} disabled={loading}>
          Generate AI Thesis
        </button>
      )}
      {loading && <div className="thesis-loading">Generating thesis for {symbol}...</div>}
      {error && <div className="thesis-error">{error}</div>}
      {thesis && (
        <div className="thesis-content">
          <h5 className="thesis-title">{symbol} AI Thesis</h5>
          {thesis.summary && <p className="thesis-summary">{thesis.summary}</p>}
          <div className="thesis-grid">
            {thesis.bull_case && (
              <div className="thesis-section thesis-bull">
                <h6>Bull Case</h6>
                <p>{thesis.bull_case}</p>
              </div>
            )}
            {thesis.bear_case && (
              <div className="thesis-section thesis-bear">
                <h6>Bear Case</h6>
                <p>{thesis.bear_case}</p>
              </div>
            )}
            {thesis.key_catalysts && (
              <div className="thesis-section thesis-catalysts">
                <h6>Key Catalysts</h6>
                <p>{thesis.key_catalysts}</p>
              </div>
            )}
            {thesis.risk_factors && (
              <div className="thesis-section thesis-risks">
                <h6>Risk Factors</h6>
                <p>{thesis.risk_factors}</p>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
